import React from 'react';

// import Chevron from '../../images/Chevron.js';

const CategorySelectButtons = (props) => {
	return (
		<div className="category-switcher-table">
			<div className="category-switcher-row">
				<div onClick={props.onCategoryReset} className="category-switcher-cell category-btn-primary">
					<div className="category-switcher-btn-prim">
						<div className="category-switcher-btn-row cat-primary">
							{/*<img className={"category-switcher-icon-prim"} src="https://storage.googleapis.com/interactive-olivia/assets/map/icons/spacer.png"  alt="icon"/>*/}
							{/*<div className="text">Olivia</div>*/}
							{/*<img className={"category-switcher-icon-prim"} src="https://storage.googleapis.com/interactive-olivia/assets/map/icons/OliviaEstate_Gold_Title.png"  alt="icon"/>*/}

						</div>
					</div>
				</div>
				{props.markerGroups.map((markerGroup) =>
					<div key={markerGroup.id} id={"switcher-"+markerGroup.id} className={`category-switcher-cell ${markerGroup.colorClass}`}>
						<div onClick={categorySwitcher.bind(this, markerGroup.id, props.onCategoryChange)} className="category-switcher-btn">
							<div className="category-switcher-btn-row">
								<img className={"category-switcher-icon"} src={markerGroup.icon}  alt={markerGroup.groupName}/>
								{/*<div className="text">{markerGroup.groupName}</div>*/}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	)
};

function categorySwitcher(id, categoryChangeFunc) {
	let elem = document.getElementById('switcher-'+id);
	if (elem.classList.contains('active')) {
		[].slice.call(document.getElementsByClassName('category-switcher-cell'))
			.forEach(function(elem) {
				elem.classList.remove('active');
			});
	} else {
		[].slice.call(document.getElementsByClassName('category-switcher-cell'))
			.forEach(function(elem) {
				elem.classList.remove('active');
			});
		elem.classList.toggle('active');
	}
	categoryChangeFunc(id);
}

CategorySelectButtons.propTypes = {
	markerGroups: React.PropTypes.array,
	onCategoryChange: React.PropTypes.func
};

export default CategorySelectButtons;

// 	<button key={markerGroup.id} onClick={categorySwitcher.bind(this, markerGroup.id, props.onCategoryChange)} className={"category-switcher-btn " + markerGroup.colorClass}></button>)



/** WEBPACK FOOTER **
 ** ./src/modules/location/elements/CategorySelectButtons.js
 **/